var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('transition-group', {
    staticClass: "tag-wrapper",
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.enter,
      "afterEnter": _vm.afterEnter,
      "leave": _vm.leave
    }
  }, [_vm._l(_vm.activeLivingOptions, function (livingOption, index) {
    return [_vm._l(livingOption.markers, function (marker, i) {
      return [livingOption.showOnMap ? _c('tag-basic', _vm._b({
        key: livingOption._id + i + 'tag',
        class: {
          'tag-basic--sold-out': _vm.isSoldOut(livingOption)
        },
        attrs: {
          "pos": {
            x: marker.x,
            y: marker.y
          },
          "show-sold-label": _vm.showSoldLabel(livingOption),
          "label": livingOption.displayName,
          "filtered": livingOption.filtered
        },
        nativeOn: {
          "click": function click($event) {
            return _vm.navigateToLivingOption(livingOption);
          }
        }
      }, 'tag-basic', marker, false)) : _vm._e()];
    }), _vm._l(livingOption.polygons, function (polygon, i) {
      return [polygon.points && polygon.points.length && livingOption.showOnMap ? _c('polygon-shape', {
        key: livingOption._id + i + 'polygon',
        class: {
          'polygon-overlay--sold-out': _vm.isSoldOut(livingOption)
        },
        attrs: {
          "polygon": polygon,
          "filtered": livingOption.filtered
        },
        nativeOn: {
          "click": function click($event) {
            return _vm.navigateToLivingOption(livingOption);
          }
        }
      }) : _vm._e()];
    })];
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }